export default __webpack_public_path__ + "static/media/prev-lesson.eb4a64dd.svg";